const brandName = 'NTUC FairPrice'
const promotextVariation1 =
  'FairPrice offers a wide range of products with prices matched online and in stores.'
const promotextVariation2 =
  'FairPrice offers a wide range of products with new promotions available frequently.'
export const metaTagDetails = {
  pwp: {
    title: `Purchase with Purchase | ${brandName} | Value Deals`,
    description: `Buy up to 4 units at discounted price with min $25.00 spent! ${promotextVariation1}`,
  },
  'weekly-deals': {
    title: `Weekly Deals | ${brandName} | New Deals Every Week`,
    description: `Browse new deals every week at NTUC FairPrice! ${promotextVariation2}`,
  },
  'value-deals': {
    title: `Value Deals | ${brandName} | Everyday Great Value`,
    description: `Enjoy greater value when you shop at FairPrice! ${promotextVariation1}`,
  },
  'clearance-sale': {
    title: `Clearance Sale | ${brandName} | Lowest Prices`,
    description: `Items from your favourite brands are going fast! ${promotextVariation1}`,
  },
  'carton-deals': {
    title: `Carton Deals | ${brandName} | Great Value Bulk Buys`,
    description:
      'Enjoy greater savings on your bulk purchases! Your heavy items are conveniently delivered right to your doorstep.',
  },
  'free-gift-with-purchase': {
    title: `Free Gift with Purchase | ${brandName} | Value for Money`,
    description:
      'Enjoy greater value with every dollar spent! Bring home FREE gifts with purchase of participating products.',
  },
  'hot-deals-this-week': {
    title: `Hot Deals this Week | ${brandName} | New Deals Every Week`,
    description: `Browse the best deals every week at NTUC FairPrice! FairPrice offers a wide range of products with new promotions available frequently.`,
  },
  'brand-deals': {
    title: `Brand Deals | ${brandName} | Everyday Great Value`,
    description: `Shop your favourite brands at the best deals. ${promotextVariation2}`,
  },
  '2-day-specials': {
    title: `2 Day Specials | ${brandName} | Best Value Flash Sale`,
    description: `2-day flash sale of your favourite items at great prices. ${promotextVariation2}`,
  },
  '1-day-specials': {
    title: `1 Day Special | ${brandName} | Best Value Flash Sale`,
    description: `1-day flash sale of your favourite items at great prices. ${promotextVariation2}`,
  },
  'category-specials': {
    title: `Category Specials | ${brandName} | Best Value`,
    description: `Browse the best deals per category at NTUC FairPrice! ${promotextVariation1}`,
  },
}
